import { useEffect } from "react"
import WalletDashboardCard from "./WalletDashboardCard"
import { useDispatch, useSelector } from "react-redux"
import { getTransactionHistory } from "../redux/slices/walletSlice"
import { useParams } from "react-router"
import { openTransactionInExplorer } from "../utils/walletUtils"
import TransactionHistory from "./shared/TransactionHistory"


function ActivityView() {
  const dispatch = useDispatch();
  const activity = useSelector(state => state.wallet.activity);
  const transactionHistory = useSelector(state => state.wallet.transactionHistory);
  const loading = useSelector(state => state.wallet.loading || state.wallet.transactionHistory.loading);
  const error = useSelector(state => state.wallet.error || state.wallet.transactionHistory.error);
  const params = useParams();
  const mode = useSelector(state => state.mode.mode);
  const activityId = params.id;

  useEffect(() => {
    document.title = "Activity - KAXAA Wallet"

    if (activityId) {
      dispatch(getTransactionHistory({ coinId: activityId, mode, page: 1, limit: 50 }));
    }
  }, [activityId, mode]);
  console.log(activity);

  // Use transaction history from new Redux state or fallback to activity
  const displayTransactions = transactionHistory?.transactions || activity?.transactions || []

  const handleTransactionClick = (tx) => {
    const txHash = tx.hash || tx.txHash || tx.transactionHash || tx.txId;
    if (txHash) {
      const network = tx.network || tx.chain || 'polygon';
      openTransactionInExplorer(txHash, network);
    }
  }
  console.log(displayTransactions);

  return (
    <div className="app-container">
      <main className="content-area">
        <div className="wallet-dashboard">
          <div
            className="grid grid-cols-[600px_1fr] gap-[30px] items-start dashboard-columns"
          >
            <div className=" sticky top-10">
              <WalletDashboardCard />
              {/* <QuickExchangeInfoCard /> */}
            </div>
            <div>
              <h1 className="text-2xl font-bold mb-4">
                Transaction History for {transactionHistory?.transactions?.[0]?.tokenId || activity?.coin}
                [{activity?.chain || 'Polygon'}]
              </h1>
              <div className="activity-list">
                {error ? (
                  <div className="activity-empty text-danger">Error loading activity: {error}</div>
                ) : (
                  <TransactionHistory
                    transactions={displayTransactions}
                    loading={loading}
                    pagination={transactionHistory?.pagination || {
                      page: 1,
                      limit: 50,
                      totalPages: 1,
                      totalRecords: displayTransactions.length
                    }}
                    onPageChange={(newPage) => dispatch(getTransactionHistory({ coinId: activityId, mode, page: newPage, limit: 50 }))}
                    onTransactionClick={handleTransactionClick}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

  )
}

export default ActivityView
